<ng-template #drawerTmpl>
  <sn-layout-navbar-primary [logoIsCollapse]="collapsed || canSeeSecondaryNavbar" [isDark]="isDark">
    <ng-content></ng-content>
  </sn-layout-navbar-primary>

  <sn-layout-navbar-secondary
    *ngIf="canSeeSecondaryNavbar"
    [componentOrTemplate]="secondaryNavbar"
    [config]="secondaryNavbarConfig"
    [width]="secondaryNavbarWidth"
  >
  </sn-layout-navbar-secondary>

  <sn-layout-navbar-collapse-button *ngIf="!collapseButtonIsHidden">
  </sn-layout-navbar-collapse-button>
</ng-template>
